export default __webpack_public_path__ + "assets/bg.ba970f2.webp";